import { HttpClient, HttpContext } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LoginDTO } from "./dtos/login-request.dto";
import { map, tap } from "rxjs";
import { ApiResponse } from "shared/interfaces/response";
import { LoginResponse } from "./dtos/login-response.dto";
import { StorageService } from "core/services/storage.service";
import { ResetPasswordRequestDTO } from "./dtos/reset-password-request.dto";
import { ForgetPasswordResponseDTO } from "./dtos/forget-password-response.dto";
import { ResetPasswordResponseDTO } from "./dtos/reset-password-response.dto";
import { ForgetPasswordRequestDTO } from "./dtos/forget-password-request.dto";
import { RouterService } from "core/services/router.service";
import { ChangePasswordRequestDTO } from "./dtos/change-password-request.dto";
import { User } from "shared/models/users/user";
import { RegisterFCMTokenRequestDTO } from "./dtos/register-fcm-token-request.dto";
import { SKIP_GLOBAL_LOADER } from "core/tokens/http-context.token";
import { RegisterFCMTokenResponseDTO } from "./dtos/register-fcm-token-response.dto";

@Injectable({
    providedIn: 'root'
})

export class AuthService {
    constructor(
        private http: HttpClient,
        private storageService: StorageService,
        private routerService: RouterService
    ) { }

    login(body: LoginDTO) {
        return this.http.post<ApiResponse<LoginResponse>>(`auth/super-admin-login`, body).pipe(
            tap((resp) => {
                if (resp.isSuccess) {
                    this.setAuthData(resp.data);
                }
            })
        )
    }

    forgetPassword(body: ForgetPasswordRequestDTO) {
        return this.http.post<ApiResponse<ForgetPasswordResponseDTO>>(`auth/forget-password`, body).pipe(
            map(resp => ({ ...resp, data: new ForgetPasswordResponseDTO(resp.data) }))
        )
    }

    resetPassword(body: ResetPasswordRequestDTO) {
        return this.http.post<ApiResponse<ResetPasswordResponseDTO>>(`auth/reset-password`, body).pipe(
            map(resp => ({ ...resp, data: new ResetPasswordResponseDTO(resp.data) }))
        )
    }

    setAuthData(data: LoginResponse) {
        this.storageService.accessToken = data?.accessToken;
        this.storageService.user = data.user;
    }

    logout() {
        return this.http.post(`auth/logout`, {}).pipe(
            tap(() => {
                this.storageService.clearStorage();
                this.routerService.goToLogin();
            })
        )
    }

    changePassword(body: ChangePasswordRequestDTO) {
        return this.http.post<ApiResponse>(`auth/change-password`, body)
    }

    getMyProfile() {
        return this.http.get<ApiResponse<User>>(`users/profile`).pipe(
            map((resp) => ({ ...resp, data: new User(resp.data) })),
            tap((resp) => this.storageService.user = resp.data)
        )
    }

    registerFCMToken(body: RegisterFCMTokenRequestDTO) {
        const context = new HttpContext().set(SKIP_GLOBAL_LOADER, true);
        return this.http.post<ApiResponse<RegisterFCMTokenResponseDTO>>(`push-notifications/register`, body, { context }).pipe(
            map(resp => ({ ...resp, data: resp.data }))
        )
    }
}